/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Tr } from '../../../../_metronic/i18n/Tr'
import 'react-phone-input-2/lib/style.css'


const ViewBookingAutoRejectTimer = () => {
    let t = Tr()
    const { menuId ,menuIdEdit } = useMenuIdPermissions()
    const tmp = sessionStorage.getItem('admin')
    const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

    const [error, setError] = useState(Object)
    const [hours, setHours] = useState('')
    const [autoRejectTimerLoading, setAutoRejectTimerLoading] = useState(false)
    const viewBookingRejectedHours = async () => {

        var res = await fetchData('admin/bookingrejectedhourview', {})

        if (res.status == '200') {
            var data = res.data
            setHours(data.value)
        } else {
            toasterrormsg(res.message)
        }
    }


    useEffect(() => {
        viewBookingRejectedHours()
    }, [])


    const removeError2 = (err: any) => {
        // Ensure error is an array before spreading
        var tmp = Array.isArray(error) ? [...error] : [{}]

        // Ensure the first object exists
        if (!tmp[0]) tmp[0] = {}

        tmp[0][err] = '' // Clear the specific error key
        setError(tmp)
    }

    const cancelHoursValidate = () => {
        var isValid = true

        var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array
        if (hours == '') {
            errorTmp[0].hours = t('Rejection Hour Is Required')
            isValid = false
        } else if (hours < '1') {
            errorTmp[0].hours = t('Rejection Hour Is Not Valid')
            isValid = false
        }

        setError(errorTmp)

        if (isValid) {
            saveHours()
        }
    }


    const saveHours = async () => {
        setAutoRejectTimerLoading(true)
        const param = {
            hours: hours,
            adminId,
        }
        var res = await fetchData('admin/bookingrejectedhourchange', param)

        if (res.status == '200') {
            setAutoRejectTimerLoading(false)
            toastsuccessmsg(res.message)
        } else {
            setAutoRejectTimerLoading(false)
            toasterrormsg(res.message)
        }
    }


    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{t('View Booking Auto Reject Timer')}</PageTitle>

            <div className='row justify-content-between'>
                <div className='col-lg-6 col-md-12 mb-4'>
                    <div className='card p-5 h-100'>
                        <div className='card-header'>
                            <div className='card-title m-0'>
                                <h3 className='fw-bolder m-0'>{t('Bookings Auto-Rejection Timer')}</h3>
                            </div>
                        </div>

                        <div className='card-body p-9'>
                            <div className='col-lg-12'>
                                <label className='fw-bold text-muted'>
                                    {t('Set Auto-Rejection Time for Pending Bookings')}
                                </label>
                                <div className='mt-5 mb-5'>
                                    <input
                                        type='text'
                                        placeholder={t('Add hours limit')}
                                        className='form-control form-control-solid w-100'
                                        value={hours}
                                        onChange={(event: any) => {
                                            setHours(event.target.value)
                                            removeError2('hours')
                                        }}
                                    />

                                    <label className='text-danger'>{error.length > 0 ? error[0].hours : ''}</label>
                                </div>{' '}
                            </div>
                            {menuIdEdit ? (
                                <button
                                    disabled={autoRejectTimerLoading}
                                    className='btn btn-success'
                                    onClick={() => {
                                        cancelHoursValidate()
                                    }}
                                >
                                    {!autoRejectTimerLoading && t('Save')}
                                    {autoRejectTimerLoading && (
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            {t('Please wait...')}{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    )}
                                </button>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>


            </div>



        </>
    )
}

export { ViewBookingAutoRejectTimer }
